import React from 'react';

import {
  ContentGroup,
  Grid,
  GridItem,
  Heading,
  Hr,
  List,
  ListItem,
  Main,
  Paragraph,
  Strong,
  Text,
} from '@constellation/core';
import { useContent } from '@interstellar/react-app-content';
import MetaTags from 'client/components/metaTags/MetaTags';
import { NavigationTiles } from 'client/components/navigationTiles';
import { StyledLink } from 'client/components/styledLink/StyledLink';

import { LimitedCompanyLaunchContent } from './LimitedCompanyLaunch.config';
import * as routes from '../manifest';

function LimitedCompanyLaunchPage(): React.JSX.Element {
  const {
    metaContent,
    backLabel,
    heading,
    atBmSolutions,
    weDeveloped,
    keyCriteria,
    process,
    helpfulInformation,
  } = useContent<LimitedCompanyLaunchContent>();

  return (
    <Main>
      <MetaTags metaContent={metaContent} />
      <Hr marginTop="none" />
      <StyledLink iconPosition="left" to={routes.Home}>
        {backLabel}
      </StyledLink>
      <ContentGroup marginTop="05">
        <Heading as="h1" size="s7">
          {heading}
        </Heading>
      </ContentGroup>
      <Hr />

      <Grid>
        <GridItem sm={12} md={8}>
          <Paragraph>{atBmSolutions}</Paragraph>
          <Paragraph>{weDeveloped}</Paragraph>
          <Hr />

          <Heading as="h2">{keyCriteria.heading}</Heading>
          <List>
            {keyCriteria.listItems.map((item, index) => (
              <ListItem key={item.split(' ')[0]}>
                <Strong>{keyCriteria.boldListItems[index]}</Strong>
                <Text>{item}</Text>
              </ListItem>
            ))}
          </List>
          <Hr />

          <Heading>{process.heading}</Heading>
          <List>
            {process.listItems.map((item) => (
              <ListItem key={item.split(' ')[0]}>{item}</ListItem>
            ))}
          </List>
          <Hr />

          <Heading as="h2">{helpfulInformation.heading}</Heading>
        </GridItem>
      </Grid>
      <NavigationTiles
        navigationTiles={helpfulInformation.navigationTiles}
        pageTestId="helpful-information-tile"
        icon="right"
      />
    </Main>
  );
}

export default LimitedCompanyLaunchPage;
